import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { MatDatepickerInputEvent } from "@angular/material/datepicker";
import {FormControl} from "@angular/forms";
import { AppConstants } from "../../../app-constants";

@Component({
    selector: 'app-weave-date-picker',
    templateUrl: './weave-date-picker.component.html',
    styleUrls: ['./weave-date-picker.component.scss'],
    standalone: false
})
export class WeaveDatePickerComponent implements OnInit, OnChanges {
  @Input() data: string;
  @Input() disabledFlag: boolean;
  @Input() label: string = "";
  @Input() placeholder: string = "";
  @Input() yearOnly: boolean = false;
  @Input() allowClear: boolean = false;
  @Input() type: number = 1; //possible types: 1, 2
  @Input() onlyEditMode:boolean = false;
  @Input() required:boolean = false;
  @Input() longTitle:boolean = false;
  @Output() focusOut: EventEmitter<string> = new EventEmitter<string>();
  @Output() datePickerClosed: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() focusIn: EventEmitter<boolean> = new EventEmitter<boolean>();

  dataDate: Date | null = null;
  id: string = "";

  editMode: boolean = false;

  constructor() {}

  ngOnInit() {
    this.initialize();
  }

  ngOnChanges() {
    this.initialize();
  }

  initialize() {
    if(this.onlyEditMode) {
      this.editMode = true;
    }

    this.id = "weave-datepicker" + Math.floor(Math.random() * 1000);
    if(this.data && this.data != AppConstants.invalidDate) {
      this.dataDate = new Date( this.data );
    } else {
      this.dataDate = null;
    }
  }

  changeToEdit(event) {
    if( !this.disabledFlag) {
      this.editMode = true;
    }
  }

  onDatePickerPopupClose(){
    this.datePickerClosed.emit(true);
    if(!this.onlyEditMode) {
      this.editMode = false;
    }
  }

  onFocusOut(data: MatDatepickerInputEvent<any>) {
    this.dataDate = data.value;
    if(!this.onlyEditMode) {
      this.editMode = false;
    }
    this.data = this.convertDate(this.dataDate);
    console.log(this.data);
    this.focusOut.emit( this.data );
  }

  onFocusIn() {
    this.focusIn.emit(true);
  }

  convertDate(date: Date) {
    if(this.yearOnly) {
      return date.getFullYear() + "";
    } else {
      let month = date.getMonth() + 1;
      return month + "/" + date.getDate() + "/" + date.getFullYear();
    }
  }

  clearDate() {
    this.dataDate = null;
    this.data = "";
    this.focusOut.emit( this.data );
  }

  dateSet(dateString) {
    if(!dateString) {
      return new Date().toISOString();
    }
    if(!this.isValidDate(dateString)) return String();
    return (new Date(dateString)).toISOString();
  };

  isValidDate(dateString) {
    let d = new Date(dateString);
    return d instanceof Date && !isNaN(d.getDate());
  }
}
